/**
 * Convert Cart Price Styling Fix
 * 
 * This script detects and styles the compare price in Convert Cart's add-to-cart button
 * to match the tilted strikethrough styling used elsewhere on the site.
 */

(function() {
    'use strict';
  
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initConvertCartPriceFix);
    } else {
      initConvertCartPriceFix();
    }
  
    function initConvertCartPriceFix() {
      let isProcessing = false; // Flag to prevent infinite loops
  
      /**
       * Apply styling to convert cart prices
       */
      function styleConvertCartPrices() {
        if (isProcessing) {
          return false;
        }
        
        // Try multiple selectors to find the ConvertCart button
        const convertCartButton = document.querySelector('.cc-action-atc .cc-button-text') || 
                                   document.querySelector('.cc-btn-atc .cc-action-atc .cc-button-text');
        
        if (!convertCartButton) {
          return false;
        }
  
        let buttonText = convertCartButton.innerHTML;
        
        // Fix double dollar sign issue - remove duplicate $ symbols
        // Match pattern like "$ $109.00" and replace with "$109.00"
        const originalText = buttonText;
        buttonText = buttonText.replace(/\$\s*\$/g, '$');
        
        // If we fixed a double dollar sign, update the button
        if (originalText !== buttonText && !buttonText.includes('cc-compare-price')) {
          isProcessing = true;
          convertCartButton.innerHTML = buttonText;
          setTimeout(() => { isProcessing = false; }, 100);
        }
        
        // Check if already styled to prevent re-styling
        if (buttonText.includes('cc-compare-price')) {
          return true;
        }
  
        // Check if there are two prices (compare price + regular price)
        const priceMatches = buttonText.match(/\$[\d,]+\.?\d*/g);
        
        if (priceMatches && priceMatches.length >= 2) {
          const comparePrice = priceMatches[0];
          const regularPrice = priceMatches[1];
          
          // Parse prices to compare
          const comparePriceValue = parseFloat(comparePrice.replace(/[$,]/g, ''));
          const regularPriceValue = parseFloat(regularPrice.replace(/[$,]/g, ''));
          
          // Only apply styling if compare price is greater than regular price
          if (comparePriceValue > regularPriceValue) {
            isProcessing = true; // Set flag before making changes
            
            // Create new HTML with styled compare price and strikethrough
            const newHTML = buttonText.replace(
              comparePrice,
              `<span class="cc-compare-price" style="position: relative; color: #fff; font-size: 14px; text-decoration: none; display: inline-block; margin-right: 4px;">${comparePrice}</span>`
            );
            
            convertCartButton.innerHTML = newHTML;
            
            // Add strikethrough line after DOM update
            setTimeout(() => {
              const comparePriceSpan = convertCartButton.querySelector('.cc-compare-price');
              
              if (comparePriceSpan && !comparePriceSpan.querySelector('.strikethrough-line')) {
                const strikethrough = document.createElement('span');
                strikethrough.className = 'strikethrough-line';
                strikethrough.style.cssText = 'content: ""; position: absolute; left: 0; top: 50%; width: 100%; height: 2px; background-color: #fff; transform: translateY(-50%) rotate(-8deg); transform-origin: center; pointer-events: none;';
                comparePriceSpan.appendChild(strikethrough);
              }
              isProcessing = false;
            }, 50);
            
            return true;
          }
        }
        
        return false;
      }
  
      /**
       * Setup MutationObserver to watch for Convert Cart button changes
       */
      function setupMutationObserver() {
        const observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            // Check if the Convert Cart button or its content has been added/modified
            if (mutation.type === 'childList' || mutation.type === 'characterData') {
              const convertCartButton = document.querySelector('.cc-action-atc .cc-button-text') || 
                                         document.querySelector('.cc-btn-atc .cc-action-atc .cc-button-text');
              if (convertCartButton) {
                styleConvertCartPrices();
              }
            }
          });
        });
  
        // Observe the entire body for changes (Convert Cart may inject content dynamically)
        observer.observe(document.body, {
          childList: true,
          subtree: true,
          characterData: true,
          characterDataOldValue: true
        });
      }
  
      /**
       * Listen for variant changes and update Convert Cart prices
       */
      function setupVariantChangeListener() {
        document.addEventListener('change', function(e) {
          if (e.target.matches('.m-dropdown-options input, input[name*="option"]')) {
            // Wait for Convert Cart to update, then re-style
            setTimeout(function() {
              styleConvertCartPrices();
            }, 500);
          }
        });
      }
  
      /**
       * Retry logic to ensure styling is applied even if Convert Cart loads slowly
       */
      function retryStyleApplication(attempts = 0, maxAttempts = 20) {
        const success = styleConvertCartPrices();
        
        if (!success && attempts < maxAttempts) {
          setTimeout(function() {
            retryStyleApplication(attempts + 1, maxAttempts);
          }, 500);
        }
      }
  
      // Initialize everything
      setupMutationObserver();
      setupVariantChangeListener();
      
      // Initial styling attempt with retries
      retryStyleApplication();
    }
  })();
  